







































import { Prop, ProvideReactive } from 'vue-property-decorator'
import { Component, mixins } from '@niknevis/vue-modules'
import { QsPaginatableMixin } from '@/modules/shared/mixins/qs-paginatable.mixin'
import { QsSearchableMixin } from '@/modules/shared/mixins/qs-searchable.mixin'
import { ContentItemCollectionTypeInAdmin } from '@/modules/content-item/models/content-item-collection.model'
import PaginationWithInput from '@/modules/shared/components/shared/pagination/PaginationWithInput.vue'
import AdminLayout from '@/modules/common/layout/components/admin/AdminLayout.vue'
import FilterRow from '@/modules/common/filter/components/shared/layout/FilterRow.vue'
import { DatePresetTypes, Filter, FilterTypes } from '@/modules/common/filter/filter'
import AdminUserSearchFilter from '@/modules/user/components/admin/AdminUserSearchFilter.vue'
import TesTable from '@/modules/common/tes-table/components/shared/TesTable.vue'
import QTable from 'quasar/src/components/table/QTable.js';
import { getContentItemColumnsInAdmin } from '@/modules/content-item/models/columns/content-item.column'
import AdminContentItemRow from '@/modules/content-item/components/admin/table/AdminContentItemRow.vue'
import AdminContentManagerSearchFilter from '@/modules/user/components/admin/AdminContentManagerSearch.filter.vue'
import TableExportButton from '@/modules/common/table-export/components/TableExportButton.vue'
import { AdminContentItemRoutes } from '@/modules/content-item/routes/admin-content-item.route'

@Component({
  layout: AdminLayout,
  layoutProps: {
    page_header: 'آیتم های تولید محتوا'
  },
  metaInfo: {
    title: 'آیتم های تولید محتوا'
  },
  components: {
    TableExportButton,
    TesTable,
    PaginationWithInput,
    FilterRow
  }
})
export default class AdminContentItemIndexPage extends mixins(
  QsPaginatableMixin,
  QsSearchableMixin
) {

  constructor(
    private readonly contentItemRoutes: AdminContentItemRoutes
  ) {
    super()
  }

  @ProvideReactive()
  @Prop() contentItems!: ContentItemCollectionTypeInAdmin
  protected columns: QTable['columns'] = getContentItemColumnsInAdmin()
  private rowComponent = AdminContentItemRow

  private filters = [
    new Filter({
      type: FilterTypes.ComboBox,
      title: 'وضعیت',
      holder: 'درحال اجرا',
      typeMode: false,
      key: 'statuses',
      items: Object.entries(this.contentItems.statuses).map(([key, value]) => ({ label: value, value: key }))
    }),
    new Filter({
      type: FilterTypes.DateRange,
      title: 'تاریخ ثبت',
      holder: 'انتخاب کنید',
      typeMode: false,
      keys: {
        from: 'register_at_from',
        to: 'register_at_to'
      },
      presets: [
        DatePresetTypes.today,
        DatePresetTypes.yesterday,
        DatePresetTypes.currentWeek,
        DatePresetTypes.custom
      ]
    }),
    new Filter({
      type: FilterTypes.DateRange,
      title: 'تاریخ تقریبی تحویل',
      holder: 'انتخاب کنید',
      typeMode: false,
      keys: {
        from: 'deliver_at_from',
        to: 'deliver_at_to'
      },
      presets: [
        DatePresetTypes.today,
        DatePresetTypes.yesterday,
        DatePresetTypes.currentWeek,
        DatePresetTypes.custom
      ]
    }),
    new Filter({
      type: FilterTypes.DateRange,
      title: 'تاریخ تکمیل',
      holder: 'انتخاب کنید',
      typeMode: false,
      keys: {
        from: 'completed_at_from',
        to: 'completed_at_to'
      },
      presets: [
        DatePresetTypes.today,
        DatePresetTypes.yesterday,
        DatePresetTypes.currentWeek,
        DatePresetTypes.custom
      ]
    }),
    new Filter({
      type: FilterTypes.Custom,
      component: AdminUserSearchFilter,
      title: 'کاربر',
      typeMode: false,
      key: 'user',
      props: {
        placeholder: 'جستجو کاربر'
      }
    }),
    // new Filter({
    //   type: FilterTypes.Custom,
    //   component: AdminWriterSearchFilter,
    //   title: 'نویسنده',
    //   typeMode: false,
    //   key: 'writer',
    //   props: {
    //     placeholder: 'جستجو نویسنده'
    //   }
    // }),
    new Filter({
      type: FilterTypes.Custom,
      component: AdminContentManagerSearchFilter,
      title: 'ویراستار',
      typeMode: false,
      key: 'editor',
      props: {
        placeholder: 'جستجو ویراستار'
      }
    })
  ]

  protected get model(): ContentItemCollectionTypeInAdmin {
    return this.contentItems
  }

  private updatePage(page: number) {
    this.updateTable({
      pagination: {
        ...this.pagination,
        page
      }
    })
  }
}
